import React, { useState, useEffect } from 'react';
import Webcam from 'react-webcam';

const CameraConfig = () => {
  const [devices, setDevices] = useState([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState(null);

  // Fetch video input devices on mount
  useEffect(() => {
    const fetchDevices = async () => {
      try {
        // Ensure the user has granted permissions before enumerating devices.
        await navigator.mediaDevices.getUserMedia({ video: true });
        const allDevices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = allDevices.filter(device => device.kind === 'videoinput');
        setDevices(videoDevices);
      } catch (err) {
        console.error("Error accessing media devices.", err);
      }
    };

    fetchDevices();
  }, []);

  // Update selected device based on URL params once devices are available
  useEffect(() => {
    if (devices.length === 0) return;

    // Parse URL parameters (e.g., ?camera=camera1 or ?camera=camera2)
    const params = new URLSearchParams(window.location.search);
    const cameraParam = params.get('camera');
    
    // Default to the first camera if no valid param is provided
    let deviceIndex = 0;
    if (cameraParam === 'camera1') {
      deviceIndex = 0;
    } else if (cameraParam === 'camera2') {
      deviceIndex = 1;
    }
    
    // Check if the device exists
    if (devices[deviceIndex]) {
      setSelectedDeviceId(devices[deviceIndex].deviceId);
    } else {
      console.warn('Selected camera not available. Falling back to default camera.');
      setSelectedDeviceId(devices[0].deviceId);
    }
  }, [devices]);

  // Set video constraints with the selected device ID
  const videoConstraints = {
    deviceId: selectedDeviceId ? { exact: selectedDeviceId } : undefined,
    width: 1920,
    height: 1080,
  };

  return (
    <div>
      {selectedDeviceId ? (
        <Webcam
          audio={false}
          videoConstraints={videoConstraints}
          style={{ width: '100%', height: '100%' }}
        />
      ) : (
        <p>Loading camera...</p>
      )}
    </div>
  );
};

export default CameraConfig;
